export default __webpack_public_path__ + "static/media/LampPost2.f9e17ea4.jpg";